import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { ReviewService } from "../api";

export const actionCreateReview = createAsyncThunk(
  "review/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await ReviewService.doCreateReview(data);

      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);

const reviewSlice = createSlice({
  name: "review",
  initialState: {
    createReview: {
      loading: false,
      data: null,
      error: "",
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // createReview
      .addCase(actionCreateReview.pending, (state) => {
        state.createReview.loading = true;
      })
      .addCase(actionCreateReview.fulfilled, (state, action) => {
        state.createReview.loading = false;
        state.createReview.data = action.payload;
      })
      .addCase(actionCreateReview.rejected, (state, action) => {
        state.createReview.loading = false;
        state.createReview.data = action.payload;
        state.createReview.error =
          action.error.message || "Something went wrong";
      });
  },
});

export default reviewSlice.reducer;
export const { actions, reducer } = reviewSlice;
